import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { getCoverTypes } from "../store/quotes";
import * as theme from "../theme";
import { getCoverImportances, getCoverTableAsArray } from "../store/quotes";
import { getRowDetailsFromProspectId } from "../store/myquotes";
import { getBrokerInformation } from "../store/broker";

const CoverTypeSelection = ({ onChange, prospectid, prospectDetails }) => {
  const [selectedCoverTypes, setSelectedCoverTypes] = useState([]);
  const coverTypes = useSelector(getCoverTypes);
  const covers = useSelector(getCoverTableAsArray);
  const coverImportance = useSelector(getCoverImportances);
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;
  const coverTypesImportance = () => {
    return coverImportance?.map((item) => {
      if (
        item.importance !== -1 &&
        prospectDetails &&
        item.verticalid === prospectDetails.calculatedverticalid
      ) {
        return item.coverid;
      }
    });
  };
  const getFilteredCoverType = async (ids) => {
    const filteredCoverTypeCode = new Set();
    await covers?.map((item) => {
      if (ids.includes(item.id)) {
        filteredCoverTypeCode.add(item?.covertypecode);
      }
    });
    return [...filteredCoverTypeCode];
  };
  useEffect(async () => {
    const verticalId = prospectDetails?.calculatedverticalid
      ? prospectDetails?.calculatedverticalid
      : prospectDetails?.selectedverticalid;
    const coverIds = coverTypesImportance(verticalId).filter(Boolean);

    const filterCoverTypes = await getFilteredCoverType(coverIds && coverIds);
    setSelectedCoverTypes(
      coverTypes.filter((item) => filterCoverTypes.includes(item?.code))
    );
  }, [coverTypes, prospectDetails]);

  return (
    <section
      style={{
        marginBottom: "5px",
      }}
    >
      <select
        name="Select Coverages"
        style={{
          borderRadius: "10px",
          border: "0px",
          width: "100%",
          height: "6vmin",
          paddingLeft: "2vmin",
          paddingRight: "2vmin",
          backgroundColor: theme.COLORS.tertiary_ligthindigo,
        }}
        onChange={(event) => {
          onChange(event.target.value);
        }}
      >
        {/* <option disabled selected>
          All Coverages
        </option> */}
        {selectedCoverTypes &&
          selectedCoverTypes.map((item, i) => (
            <option key={i} value={item && item.code} style={{ height: "3vh" }}>
              {item && item.name[languagepreference]}
            </option>
          ))}
      </select>
    </section>
  );
};

export default CoverTypeSelection;
